import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Grid,
} from "@mui/material";

function AddXpDialog({
  open,
  setOpen,
  addXpAmount,
  setAddXpAmount,
  addXpHandler,
}) {
  const handleClose = () => setOpen(false);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Add XP Rewards</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12} sx={{ m: 0, p: 1 }}>
            <TextField
              id="amount"
              label="Amount"
              fullWidth
              value={addXpAmount}
              variant="standard"
              onChange={(e) => setAddXpAmount(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={addXpHandler} autoFocus disabled={false}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddXpDialog;
